module.exports = _.isEqual;


//////////////////
// WEBPACK FOOTER
// external "_.isEqual"
// module id = 266
// module chunks = business-manager/shoutout-popup business-manager/video-library-page shoutout/shoutout full-screen-modals/full-screen-modals mobile-overlay/mobile-overlay mobile/mobile widget/widget dashboard/dashboard app-settings/app-settings